__webpack_require__.p = "/mi-assets/mi-static/mi-shop-renderer-2/web-rel-26.8.2-081120261100/_next/";